import { useFormContext } from 'react-hook-form';

import { getPollIcon } from './helpers/getPollIcon';
import { TMarketingForm } from './MarketingPoll';
import styles from './PollOptionButton.module.css';

export type TPollOption = {
  id: string;
  name: string;
};

const PollOptionButton = ({
  option,
  onChange,
}: {
  option: TPollOption;
  onChange: () => void;
}) => {
  const { register } = useFormContext<TMarketingForm>();

  return (
    <label className={styles.marketingPollBtn}>
      {getPollIcon(option.id)}
      <p className={styles.pollName} aria-label={option.name}>
        {option.name}
      </p>
      <input
        type="radio"
        {...register('answer')}
        value={option.id}
        className={styles.marketingPollInput}
        onInput={onChange}
      />
    </label>
  );
};

export default PollOptionButton;
